export const SET_USER = 'SET_USER';
export const SET_INFO = 'SET_INFO';

export function setUser(user) {
    return { type: SET_USER, payload: user };
}

export function setInfo(info) {
    return { type: SET_INFO, payload: info };
}